module.exports = __webpack_public_path__ + "static/media/onda-violeta-modal.1d83f9aa.png";